import GradientButton from '@/components/UI/GradientButton';
import { HomeTitle } from '../../style';
import Footer from '../Footer';
import { ButtonWrapper, ContentWrapper, Description, Wrapper } from './style';
import { useAppSelector } from '@/store/hooks';
import { RootState } from '@/store/store';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export default function ReadyToStart() {
  const isLoggedIn = useAppSelector(
    (state: RootState) => state.auth.isLoggedIn
  );
  const navigate = useNavigate();
  const getStarted = useCallback(() => {
    if (isLoggedIn) {
      navigate('/pricing');
    } else {
      navigate('/sign-up');
    }
  }, [isLoggedIn]);
  return (
    <Wrapper>
      <ContentWrapper>
        <HomeTitle>Ready to Elevate Your Creativity?</HomeTitle>
        <Description>
          {
            "Don't settle for the ordinary – take the leap into extraordinary possibilities."
          }
          <br />
          {
            'Join thousands of content creators, entrepreneurs, and professionals who have already harnessed the power of our innovative solutions.'
          }
        </Description>
        <GradientButton
          onClick={getStarted}
          body={
            <ButtonWrapper>
              <p>Get Started</p>
            </ButtonWrapper>
          }
        />
      </ContentWrapper>
      <Footer fullWidth />
    </Wrapper>
  );
}
